import { Get_token } from "../../../base/js/mUtils"

export default {
    /*
     预报下单
    */
    newWarehouseOrder: {
        //客户
        GetClientForPc() {
            return Serviceface.get('/api/tmsorder/GetClientForPc' + "?token=" + Get_token() + '&key= ')
        },

        getSelectMsg() {
            return Serviceface.post('/api/fmsOrderLine/get_page_set' + "?token=" + Get_token(), ['产品', '网点', '始发地点', '目的地点', '货物类别', '币种'])
        },

        guojia() {
            return Serviceface.post('/api/flmsLineSys/get_page_set' + "?token=" + Get_token(), ['目的国家'])
        },

        getCargoNosForAdd(productId, qty, after) {
            return Serviceface.get('/api/fmsOrderLine/getCargoNosForAdd' + "?token=" + Get_token() + '&productId=' + productId + '&qty=' + qty + '&after=' + after)
        },

        fmsOrderLine(data) {
            return Serviceface.post('/api/fmsOrderLine/save' + "?token=" + Get_token(), data)
        },

        getOrderInitData(productId) {
            return Serviceface.get('/api/fmsOrderLine/getOrderInitData' + "?token=" + Get_token() + '&productId=' + productId)
        },

        getperson(keyInput) {
            return Serviceface.get('/api/fmsOrderLine/quickInput' + "?token=" + Get_token() + '&Input=' + keyInput);
        },

        /**
         * 收录收件人
         * @param {*} data 
         * @returns 
         */
        saveGetInfo(data) {
            return Serviceface.post('/api/flmsRecipientSender/recipientInfoSave' + "?token=" + Get_token(), data);
        },
        /**
         * 收录发件人
         * @param {*} data 
         * @returns 
         */
        saveSendInfo(data) {
            return Serviceface.post('/api/flmsRecipientSender/senderInfoSave' + "?token=" + Get_token(), data);
        },

        getaddress: function (value) {
            return Serviceface.get("/api/vjiyuninbound/get_area_data" + "?token=" + Get_token() +
                "&value=" +
                value)
        }
    },

    Inventory: {
        InventorylistFun(data) {
            return Serviceface.post('/api/fmsOrderLine/getCargoStoreForLoad' + "?token=" + Get_token(), data)
        },

        getInventory(list) {
            return Serviceface.post('/api/flmsLoading/addLoadingOrderBoxRels' + "?token=" + Get_token(), list)
        },

        delLoadingOrderBoxRel(orderBoxRelId) {
            return Serviceface.post('/api/flmsLoading/delLoadingOrderBoxRel' + "?token=" + Get_token() + '&orderBoxRelId=' + orderBoxRelId)
        },
    },


    Waybilllist: {
        getDataList: function (data) {
            return Serviceface.post('/api/fmsOrderLine/list' + "?token=" + Get_token(), data)
        },

        moveBoxes: function (id) {
            return Serviceface.post('/api/fmsOrderLine/flagDelOrder' + "?token=" + Get_token() + '&orderid=' + id)
        },

        delEteBtn: function (id) {
            return Serviceface.post('/api/fmsOrderLine/delOrder' + "?token=" + Get_token() + '&orderid=' + id)
        },

        restore: function (id) {
            return Serviceface.post('api/fmsOrderLine/flagReductionOrder' + "?token=" + Get_token() + '&orderid=' + id)
        },

        takegoods: function (list) {
            return Serviceface.post('/api/fmsOrderLine/getInboundDataForClient' + "?token=" + Get_token(), list)
        },

        submittakegoods: function (list) {
            return Serviceface.post('/api/fmsOrderLine/confirmInboundForClient' + "?token=" + Get_token(), list)
        },

        ExportWaybill: function (data) {
            return Serviceface.post('/api/fmsOrderLine/exportOrders' + "?token=" + Get_token(), data)
        },

        ExportContainer: function (data) {
            return Serviceface.post('/api/fmsOrderLine/exportCargos' + "?token=" + Get_token(), data)
        },

        ExportDeclarationInformation: function (data) {
            return Serviceface.post('/api/fmsOrderLine/exportItems' + "?token=" + Get_token(), data)
        },

        labelPrint: function (orderid) {
            return Serviceface.get('/api/fmsOrderLine/orderLabelPrint' + "?token=" + Get_token() + '&orderid=' + orderid)
        }
    },

    forecastDetails: {
        internationalLineDetails: function (id) {
            return Serviceface.get('/api/fmsOrderLine/get' + "?token=" + Get_token() + '&id=' + id)
        },

        costDetails: function (data) {
            return Serviceface.post('/api/fee/get_list' + "?token=" + Get_token(), data)
        },

        BasicInformation: function (id) {
            return Serviceface.get('/api/fmsOrderLine/getForEdit' + "?token=" + Get_token() + '&id=' + id)
        },

        AddpackingCase: function (id, parseInfo, data) {
            return Serviceface.post('/api/fmsOrderLine/addCargoList' + "?token=" + Get_token() + '&id=' + id + '&parseInfo=' + parseInfo, data);
        },

        declarationInformation: function (id) {
            return Serviceface.get('/api/fmsOrderLine/getItemListForEdit' + "?token=" + Get_token() + '&id=' + id);
        },

        declarationInformationEidt: function (id, parseInfo, data) {
            return Serviceface.post('/api/fmsOrderLine/editItemList' + "?token=" + Get_token() + '&id=' + id + '&parseInfo=' + parseInfo, data);
        },

        getCargoNosForEdit(id, qty) {
            return Serviceface.get('/api/fmsOrderLine/getCargoNosForEdit' + "?token=" + Get_token() + '&id=' + id + '&qty=' + qty)
        },

        uPloadImage: function (itemId, data) {
            return Serviceface.post('/api/fmsOrderLine/saveImgForOrder' + "?token=" + Get_token() + '&itemId=' + itemId, data)
        },

        deLeteImage: function (id) {
            return Serviceface.post('/api/fmsOrderLine/delOrderItems' + "?token=" + Get_token(), [id])
        },

        saveAttachmentBase64: function (id, data) {
            return Serviceface.post('/api/fmsOrderLine/saveAttachmentBase64' + "?token=" + Get_token() + '&id=' + id, data)
        },


        delAttachment: function (Id) {
            return Serviceface.get('/api/fmsOrderLine/delAttachment' + "?token=" + Get_token() + '&fileId=' + Id)
        },

        //导入申报
        importDeclaration: function (data) {
            return Serviceface.post('/api/fmsOrderLine/UploadPreSingle' + "?token=" + Get_token(), data)
        },

        deleTeBox: function (data) {
            return Serviceface.post('/api/fmsOrderLine/delCargosByIds' + "?token=" + Get_token(), data)
        }
    },

    stowage: {
        getSelectMsg() {
            return Serviceface.post('/api/flmsLineSys/get_page_set' + "?token=" + Get_token(), ['出货渠道', '始发港口', '目的港口', '始发机场', '目的机场', '目的国家', '船坞公司', '航空公司', '车型', '配载类型', '配载订单状态', '配载业务状态'])
        },
        SelectGet_companys() {
            return Serviceface.post('/api/flmsLineSys/get_companys' + "?token=" + Get_token(), ['海运订舱公司', '海运船公司', '空运订舱公司', '空运航空公司'])
        },

        getHouse: function () {
            return Serviceface.post('/api/vjielxorder/get_page_set' + "?token=" + Get_token(), ['接收网点'])
        },

        ShippingStowage: function (data) {
            return Serviceface.post('/api/flmsLoading/save_ocean' + "?token=" + Get_token(), data)
        },

        AirStowage: function (data) {
            return Serviceface.post('/api/flmsLoading/save_airport' + "?token=" + Get_token(), data)
        },

        stowageList: function (data) {
            return Serviceface.post('/api/flmsLoading/list' + "?token=" + Get_token(), data)
        },

        stowageDelete: function (id) {
            return Serviceface.post('/api/flmsLoading/delLoading' + "?token=" + Get_token() + '&id=' + id)
        },

        stowageDetails: function (id) {
            return Serviceface.get('/api/flmsLoading/get' + "?token=" + Get_token() + '&id=' + id)
        },
    },

    signlist: {
        getSignData: function (data) {
            return Serviceface.post('/api/flmsDelivery/list' + "?token=" + Get_token(), data)
        },
        PackageSign(data) {
            return Serviceface.post('/api/flmsDelivery/signFor' + "?token=" + Get_token(), data)
        }
    },

    newTrack: {
        /**
         * 新增轨迹
         * @param {*} data 
         * @returns 
         */
        newTrackInfoAdd: function (orderId, data) {
            return Serviceface.post('/api/flmsTrack/addTrack' + "?token=" + Get_token() + '&orderId=' + orderId, data)
        },

        /**
         * 删除轨迹
         * @param {*} id 
         * @returns 
         */
        delEteTrack: function (trackId) {
            return Serviceface.post('/api/flmsTrack/delTrackById' + "?token=" + Get_token() + '&trackId=' + trackId)
        }
    },

    priceInquiry: {
        getSelectMsg() {
            return Serviceface.post('/api/flmsLineSys/get_page_set' + "?token=" + Get_token(), ['目的国家', '包装类型'])
        },
        getPriceInquiry: function (id) {
            return Serviceface.post('xxxxxxxxxxxx' + "?token=" + Get_token() + '&id=' + id)
        }
    }




}